import * as React from "react";
import { useAppDispatch } from "@/store/hooks";
import { useUploadStatus } from "@/hooks/use-upload-status";
import { businessReportsApi } from "@/modules/snapshots/businessReports.api";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";

interface Props {
  refetch: () => void;
  snapshotCollectionOutcomes: BusinessReportOutcome[];
  selectedCollection: SnapshotCollection;
}

export const SnapshotCollectionsOutcomesWebsocketHandler: React.FC<Props> = ({
  snapshotCollectionOutcomes,
  refetch,
  selectedCollection,
}) => {
  const dispatch = useAppDispatch();

  useUploadStatus(msg => {
    if (
      msg.progress === 1 &&
      snapshotCollectionOutcomes.some(row => row.snapshot_tx_id === msg.tx_id && row.status === "IN_PROGRESS")
    ) {
      refetch();
    } else {
      dispatch(
        businessReportsApi.util.updateQueryData(
          "getBusinessReportsOutcome",
          {
            snapshot_collection_id: selectedCollection.id,
          },
          draftSnapshotCollectionOutcomes => {
            const index = draftSnapshotCollectionOutcomes.results.findIndex(row => row.snapshot_tx_id === msg.tx_id);

            if (index > -1) {
              const record = draftSnapshotCollectionOutcomes.results[index];
              if (record) {
                if (record.status === "NEW") {
                  record.status = "IN_PROGRESS";
                }
                record.snapshot_progress = msg.progress;
              }
            }
          },
        ),
      );
    }
  });
  return null;
};
